
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/interakt",
      function () {
        return require("private-next-pages/compare/interakt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/interakt"])
      });
    }
  